<mat-card appearance="outlined" class="survey-card" [class.bill-mat-card]="is_invoice_page">
  <mat-card-content *ngIf="like_dislike_feedback">
    <mat-card-subtitle class="question-text" [class.bill-mat-card-subtitle]="is_invoice_page">{{survey_question_text}}</mat-card-subtitle>
    <mat-card-actions>
      <button mat-raised-button [class.bill-button]="is_invoice_page" [class.survey-button]="!is_invoice_page"><fa-icon [icon]="faThumbsDown" class="fa-3x dis-like" [fixedWidth]="true" (click)="thumb_click(false)"></fa-icon></button>
      <button mat-raised-button [class.bill-button]="is_invoice_page" [class.survey-button]="!is_invoice_page"><fa-icon [icon]="faThumbsUp" class="fa-3x like" [fixedWidth]="true" (click)="thumb_click(true)"></fa-icon></button>
    </mat-card-actions>
  </mat-card-content>
  <ng-container *ngIf="show_feedback">
    <mat-card-content>
      <mat-card-subtitle [class.bill-mat-card-subtitle]="is_invoice_page">Thanks for your feedback! Care to tell us why?</mat-card-subtitle>
      <textarea matInput type="text" [class.bill-textarea]="is_invoice_page" [(ngModel)]="feedback_text" maxLength="500" placeholder="Enter your feedback here..." rows="5"></textarea>
      <div class="mat-hint-div">
        <mat-hint class="charlimit start-hint" >{{feedback_text?.length || 0}}/500</mat-hint>
       <ng-container *ngIf="is_invoice_page">
        <span class="center-submit bill-button notes-submit"   [hidden]="!feedback_text" (click)="submit_click()">SUBMIT</span>
        <span class="end-dismiss"  (click)="dismiss_click()">DISMISS</span>
       </ng-container>
        
      </div>
    </mat-card-content>
    <div class ="button-container" *ngIf="!is_invoice_page">
      <button mat-raised-button [hidden]="!feedback_text" (click)="submit_click()">Submit</button>
      <button mat-raised-button (click)="dismiss_click()">Dismiss</button>
    </div>
  </ng-container>

  <mat-card-content *ngIf="thank_feedback">
    <mat-card-subtitle>Thanks for your feedback!</mat-card-subtitle>
  </mat-card-content>
</mat-card>
